import api from './api'
import { API_ENDPOINTS } from '../utils/constants'

class BillingService {
  async getSummary() {
    const response = await api.get(API_ENDPOINTS.BILLING_SUMMARY)
    return response.data.data || response.data
  }

  async getQuote(payload) {
    const response = await api.post(API_ENDPOINTS.TASK_QUOTE, payload)
    return response.data.data || response.data
  }

  async getPaymentMethods() {
    const response = await api.get('/api/v1/billing/payment-methods')
    return response.data.data || response.data
  }

  async addPaymentMethod(paymentMethodId) {
    const response = await api.post('/api/v1/billing/payment-methods', { paymentMethodId })
    return response.data
  }

  async deletePaymentMethod(paymentMethodId) {
    const response = await api.delete(`/api/v1/billing/payment-methods/${paymentMethodId}`)
    return response.data
  }

  async setDefaultPaymentMethod(paymentMethodId) {
    const response = await api.put(`/api/v1/billing/payment-methods/${paymentMethodId}/default`)
    return response.data
  }

  async createSetupIntent() {
    const response = await api.post('/api/v1/billing/setup-intent')
    return response.data.data || response.data
  }
}

export default new BillingService()
